module.exports = __webpack_public_path__ + "static/media/test19_2.af298f7f.png";